export function objectFromArray(
  obj: Indexer<string>,
  list: Array<string>
): object {
  return list.reduce((acc: Indexer<string>, attr: string): Indexer<string> => {
    acc[attr] = obj[attr];
    return acc;
  }, {} as Indexer<string>);
}
